<div class='category'>
    <ui-view>
      {{category.CategoryName}} - you can put information here specific to a category
      <br/>
      <a uiSref='category.detail.process' [uiParams] = '{category:category}'>Show list of processes for {{category.CategoryName}}</a>
    </ui-view>
  </div>
